import store from './store';

export default {
  methods: {
    objKeys(obj) {
      if (!obj || obj == null) obj = {};
      return Object.keys(obj);
    },

    objKeysCount(obj) {
      if (!obj || obj == null) obj = {};
      return Object.keys(obj).length;
    },

    objIsEmpty(obj) {
      if (!obj || obj == null) obj = {};
      return Object.keys(obj).length == 0;
    },

    toDate(date, showTime = false, ret = 'NOT SET') {
      if (date == null) return ret;

      let options = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        timeZone: 'Asia/Kolkata',
        hour12: true,
      };

      if (showTime) {
        options.hour = 'numeric';
        options.minute = 'numeric';
      }

      if (date.indexOf('T')) {
        return new Intl.DateTimeFormat('en-In', options).format(new Date(date));
      } else {
        let d = date.split(' ')[0].split('-');
        let t = date.split(' ')[1].split(':');
        return new Intl.DateTimeFormat('en-IN', options).format(new Date(d[0], Number(d[1]) - 1, d[2], t[0], t[1], t[2]));
      }
    },

    toTime(date) {
      if (date == null) return 'NOT SET';

      let options = {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'Asia/Kolkata',
        hour12: true,
      };

      if (date.indexOf('T')) {
        return new Intl.DateTimeFormat('en-In', options).format(new Date(date));
      } else {
        let d = date.split(' ')[0].split('-');
        let t = date.split(' ')[1].split(':');
        return new Intl.DateTimeFormat('en-IN', options).format(new Date(d[0], Number(d[1]) - 1, d[2], t[0], t[1], t[2]));
      }
    },

    toInr(number, showDecimal = false) {
      if (number == undefined) return 'NOT SET';
      return '₹ ' + number;
      // return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: showDecimal ? 2 : 0 }).format(number);
    },

    getDeepValue(obj, path) {
      return path
              .replace(/\[|\]\.?/g, '.')
              .split('.')
              .filter(s => s)
              .reduce((acc, val) => acc && acc[val], obj);
    },

    request(method = 'GET', url, body = {}, successCallback, errCallback) {
      if (!url.includes('http')) url = this.$store.state.apiUrl + url;

      let requestOptions = {
        method: method,
        headers: {},
      }

      if (method == 'POST' || method == 'PUT') {
        requestOptions.headers['Accept'] = 'application/json';
        if (body instanceof FormData) {
          requestOptions.body = body;
        } else {
          requestOptions.headers['Content-Type'] = 'application/json';
          requestOptions.body = JSON.stringify(body);
        }
      }

      if (this.$store.state.api_token) requestOptions.headers['Authorization'] = 'Bearer ' + this.$store.state.api_token;

      fetch(url, requestOptions)
        .then(resp => resp.json())
        .then(resp => successCallback(resp))
        .catch(err => {
          if (errCallback) errCallback(err);
          else console.error(err);
        });
    },

    initiateCall(phone, callback = null) {
      if (store.state.user.type == 'Company Dealership') {
        this.request('POST', 'utils/initiate-call', { phone }, (resp) => {
          if (callback) {
            callback(resp);
          } else {
            alert(resp.message);
          }
        });
      } else {
        window.open('tel:' + phone, '_system');
      }
    },

    initiateMessage(type, id, channel, template, callback = null) {
      const confirmSend = confirm(`Are you sure you want to send ${channel.toUpperCase()} message?`);
      if (!confirmSend) return;
      this.request('POST', 'utils/initiate-message/' + type + '/' + id + '/' + channel + '/' + template, {}, (resp) => {
        if (callback) {
          callback(resp);
        } else {
          alert(resp.message);
        }
      });
    },

    sendBeacon(type, title, data = {}) {
      let f = new FormData();
      f.append('type', type);
      f.append('title', title);
      f.append('description', JSON.stringify(data));
      f.append('user', JSON.parse(window.localStorage.getItem('dealer_user'))['id']);

      navigator.sendBeacon(store.state.apiUrl + 'utils/beacon', f);
    },

    diffBetweenDates(date1, date2) {
      if (date1 == null || date2 == null) return 0;

      date1 = new Date(date1);
      date2 = new Date(date2);
      return (Math.ceil(Math.abs(date1 - date2) / (1000 * 60 * 60 * 24))) + 1;
    },

    openDownloadUrl(url) {
      url = url.includes('http') ? url : this.$store.state.apiUrl + url;
      window.open(url, '_system');
    },

    checkFcmToken() {
      let token = window.localStorage.getItem('dealer_fcm_token');

      if (token != null && this.$store.state.user.fcm_token != token) {
        this.request('POST', 'updateFcm', {'fcm_token': token}, (resp) => {
          if (resp.success) this.$store.state.user.fcm_token = token
        });
      }
    },

    logout(toConfirm = false) {
      if (toConfirm) if (!confirm('Do you want to Logout?')) return;

      window.localStorage.clear();
      this.$store.state.api_token = '';
      this.$store.state.user = {};
      this.$router.push('/');
    },

    async compressImage(file) {
      const img = new Image();

      img.src = await new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => { resolve(e.target.result); };

        reader.readAsDataURL(file);
      });

      await img.decode();

      const canvas = document.createElement('canvas');
      canvas.width = 1280;
      canvas.height = img.height * (1280 / img.width);

      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);

      return new Promise(r => canvas.toBlob(r, 'image/jpeg', 0.7));
    },
  },
}
